<template>
  <div>
    <v-layout column class="mt-0 ml-4">
      <header-elements icon='mdi-power-plug' @showUpload="showUpload=!showUpload" title='Electrical'></header-elements>
      <elements-table :items="all_electricals" :showUpload="showUpload" @showUpload="showUpload=!showUpload" title="Electric Device" :icons=true></elements-table>

        <v-card class="px-5 pt-0 elevation-1" v-if="showUpload">
          <!-- <v-container grid-list-xs fluid> -->
              <v-card-title class="px-0">
                <span class="subbheadline xs12">Add new Electrical Material </span>
                <v-spacer></v-spacer>
                <v-btn class="pr-0 mr-0"  small @click="showUpload=!showUpload"><v-icon small>close</v-icon> CANCEL</v-btn>
              </v-card-title>

            <v-layout row wrap>
              <v-radio-group row v-model="electrical.category" label="" class="flex xs12 mb-2">
                <v-radio v-for="s in categories" :label="s.name" :value="s.id" :key="s.id" :off-icon="s.off_icon" :on-icon="s.on_icon" :class="{ 'px-4 py-3 ml-0 mr-0 elevation-1': electrical.category != s.id, 'px-4 py-3 ml-0 mr-0 elevation-4': electrical.category == s.id }"></v-radio>
              </v-radio-group>

              <v-flex v-if="electrical.category=='monitor'" xs12 mx-0 my-0 py-0>
                <v-radio-group row v-model="electrical.specs" label="">
                  <v-radio v-for="vs in constants.MONITORS" :key="vs.id" :value="vs.title" :label="vs.title" class="ml-3"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex v-if="electrical.category=='projector'" xs12 mx-0>
                <v-radio-group row v-model="electrical.specs" label="">
                  <v-radio v-for="vs in constants.PROJECTORS" :key="vs.id" :value="vs.title" :label="vs.title" class="ml-3"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex v-if="electrical.category=='motor'" xs12 mx-0>
                <v-radio-group row v-model="electrical.specs" label="">
                  <v-radio v-for="vs in constants.MOTORS" :key="vs.id" :value="vs.title" :label="vs.title" class="ml-3"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex v-if="electrical.category=='bulb'" xs12 mx-0>
                <v-radio-group row v-model="electrical.specs" label="">
                  <v-radio v-for="vs in constants.BULBS" :key="vs.id" :value="vs.title" :label="vs.title" class="ml-3"></v-radio>
                </v-radio-group>
              </v-flex>

              <v-flex xs12 mx-3 v-if="electrical.specs=='Other'">
                <v-text-field v-model="electrical.other" label="Other"></v-text-field>
              </v-flex>

              <v-flex xs12 mx-0>
                <v-radio-group row v-model="electrical.origin" label="Origin">
                  <v-radio v-for="vs in constants.ORIGINS" :key="vs.id" :value="vs.id" :label="vs.title" class="ml-3"></v-radio>
                </v-radio-group>
              </v-flex>
              
              <v-flex class="xs12">
                <v-text-field v-model="electrical.title" label="Title"></v-text-field>
              </v-flex>

              <v-flex class="xs12 md6 pr-3">
                <v-text-field v-model="electrical.brand" label="Brand"></v-text-field>
              </v-flex>
              <v-flex class="xs12 md6">
                <v-text-field v-model="electrical.type" label="Type and Model"></v-text-field>
              </v-flex>
              <v-flex class="xs12 md6 pr-3">
                <v-text-field v-model="electrical.sn" label="Serial Number"></v-text-field>
              </v-flex>
              <v-flex class="xs12 md6">
                <v-text-field v-model="electrical.an" label="Accession Number Tech Database TBA21"></v-text-field>
              </v-flex>

              <v-flex xs12>
                <h4 class='body-2'>Date of Production</h4>
                <v-date-picker landscape label="Accession Date" v-model="electrical.production_date"></v-date-picker>
              </v-flex>

              <v-flex class="xs12">
                <v-textarea rows=1 auto-grow v-model="electrical.ionterfaces" label="Interfaces"></v-textarea>
              </v-flex>

              <v-flex class="xs12 md6 pr-3">
                <v-text-field v-model="electrical.number_of_parts" label="Number of Parts"></v-text-field>
              </v-flex>

              <v-flex class="xs12 md6">
                <v-textarea rows=1 auto-grow v-model="electrical.power_requirement" label="Power Requirement"></v-textarea>
              </v-flex>

              <v-flex class="xs12">
                <v-textarea rows=1 auto-grow v-model="electrical.installation_specifications" label="Specifications on installation"></v-textarea>
              </v-flex>
              <v-flex class="xs12">
                <v-textarea rows=1 auto-grow v-model="electrical.modification" label="Modification"></v-textarea>
              </v-flex>
              <v-flex class="xs12">
                <v-textarea rows=1 auto-grow v-model="electrical.periphals" label="Periphals"></v-textarea>
              </v-flex>
              <v-flex class="xs12">
                <v-textarea rows=1 auto-grow v-model="electrical.associated_items" label="Associated items"></v-textarea>
              </v-flex>

              <v-flex class="xs12 md3 pr-3">
                <v-text-field v-model="electrical.height" suffix="cm" label="Height"></v-text-field>
              </v-flex>
              <v-flex class="xs12 md3 pr-3">
                <v-text-field v-model="electrical.width" suffix="cm" label="Width"></v-text-field>
              </v-flex>
              <v-flex class="xs12 md3 pr-3">
                <v-text-field v-model="electrical.depth" suffix="cm" label="Depth"></v-text-field>
              </v-flex>
              <v-flex class="xs12 md3">
                <v-text-field v-model="electrical.weight" suffix="cm" label="Weight"></v-text-field>
              </v-flex>
              <!-- <edit-field-comp v-for="field in fields" v-show="(field.category ? (electrical.category===field.category) : true)" :id="field.name" :name="field.name"
                :class="'flex ' + (field.class ? field.class : 'xs12') + (field.dynamic ? ' red' : '')" :artwork="artwork" 
                :field="field" 
                :key="field.key"
                :electrical="electrical"
              >
              </edit-field-comp> -->
            </v-layout>
          <!-- </v-container> -->
          <v-flex class="xs12 ml-3 mb-3">
            <v-btn @click="save_electrical">save</v-btn>
            <v-btn @click="showUpload=!showUpload">cancel</v-btn>
          </v-flex>
        </v-card>
        <!-- <v-flex xs12 sm12 md12 v-if="all_electricals && all_electricals.length>0">
          <v-list class="xs12 mt-0 pt-0"> -->

            <!-- <template v-for="e in all_electricals">
              <v-list-tile :key="e.id">
                <v-list-tile-title :key="`title_${e.id}`">
                  <v-icon v-if="e.category=='monitor'">mdi-monitor</v-icon>
                  <v-icon v-if="e.category=='projector'">mdi-projector</v-icon>
                  <v-icon v-if="e.category=='motor'">mdi-engine</v-icon>
                  <v-icon v-if="e.category=='bulb'">mdi-lightbulb</v-icon>
                  <v-icon v-if="e.category=='switch'">mdi-nintendo-switch</v-icon>
                  <b class="ml-2">{{e.title}}</b>
                </v-list-tile-title> 
                <v-list-tile-action>
                  <v-btn @click="done_electrical" icon ><v-icon small>edit</v-icon></v-btn>
                </v-list-tile-action>
                <v-list-tile-action>
                  <v-btn @click="dialog=true" icon ><v-icon small>delete</v-icon></v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider :key="`divider${e.id}`"></v-divider>
            </template> -->

              <!-- <v-list-tile-title>Note about this electrical is empty</v-list-tile-title> -->
              <!-- <v-list-tile-title>{{e.title}}</v-list-tile-title> -->
              <!-- <v-list-tile-title>{{e.brand}} {{e.type}}</v-list-tile-title>
              <v-list-tile-action>
                <v-btn @click="done_electrical" icon ><v-icon small>edit</v-icon></v-btn>
              </v-list-tile-action>
              <v-list-tile-action>
                <v-btn @click="dialog=true" icon ><v-icon small>delete</v-icon></v-btn>
              </v-list-tile-action>
              <v-divider inset></v-divider> -->
            <!-- </v-list-tile> -->
          <!-- </v-list> -->
          <!-- <v-btn icon class="mt-0 mb-0 xs12"  @click="this.showUpload=!this.showUpload"><v-icon>add</v-icon></v-btn>
          <v-flex v-if="this.showUpload">
            <v-container grid-list-xs fluid>
              <v-layout row wrap>
                <v-text-field v-model="electrical.title" name="title" label="Title" class="flex xs12"></v-text-field>
                <v-text-field v-model="electrical.duration_min" mask="time-with-seconds" hint="HH:MM:SS" class="flex xs6" name="duration_min" label="Duration minutes"></v-text-field>
                <v-text-field v-model="electrical.duration_timecode" mask="##:##:##:##" hint="HH:MM:SS:FR" class="flex xs6" name="duration_timecode" label="Duration Timecode"></v-text-field>
              </v-layout>
            </v-container>
            <v-btn @click="add">save</v-btn>
            <v-btn @click="showUpload=!showUpload">cancel</v-btn>
          </v-flex> -->
        <!-- </v-flex> -->
        <!-- <v-flex class="mt-0 mb-0 xs12" v-show="!showUpload">
          <v-btn icon @click="showUpload=!showUpload"><v-icon>add</v-icon></v-btn>
          Add new Electrical Material
        </v-flex> -->
        
        <v-dialog v-model="dialog" max-width="400px">
          <v-card>
            <v-card-title class="headline">Are you sure you want to delete this device?</v-card-title>
            <v-card-text> This Device will be deleted. </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat="flat" @click="dialog = false">No</v-btn>
              <v-btn color="green darken-1" flat="flat" @click="deleteDevice"> Yes</v-btn>
            </v-card-actions>
          </v-card>          
        </v-dialog>

    </v-layout>
  </div>
</template>

<script>
  // import EditFieldComp from './EditFieldComp'
  import HeaderElements from './HeaderElements'
  import ElementsTable from './ElementsTable'
  export default {
    props: ['artwork','field'],
    data: () => ({
      dialog: false,
      electricals: [
        // { id:1, title: 'Bulb 1', bulb_origin: 1, bulb_specification: 'test specs'},
        // { id:3, title: 'Bulb 2', bulb_origin: 1, bulb_specification: 'test specs'},
        // { id:2, title: 'Bulb 3', bulb_origin: 1, bulb_specification: 'test specs'},
      ],
      categories: [
        {id: 'monitor', name: 'Monitor', off_icon: 'mdi-monitor', on_icon: 'mdi-monitor'},
        {id: 'projector', name: 'Projector', off_icon: 'mdi-projector', on_icon: 'mdi-projector'},
        {id: 'motor', name: 'Motor', off_icon: 'mdi-engine', on_icon: 'mdi-engine'},
        {id: 'bulb', name: 'Bulb', off_icon: 'mdi-lightbulb', on_icon: 'mdi-lightbulb'},
        {id: 'switch', name: 'Switch', off_icon: 'mdi-nintendo-switch', on_icon: 'mdi-nintendo-switch'},
      ],
      fields: [
        // {
        //   'ctype': 'radio',
        //   'selection': [{id: 1, name: 'monitor'},{id:2, name:'projector'},{id:3, name:'motor'}, {id:4, name:'bulb'}, {id:5, name:'switch'}],
        //   'name': 'category',
        //   'title': 'Category',
        //   column: false,
        //   class: 'xs12',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   'ctype': 'radio',
        //   'selection': [{id: 1, name: 'LCD'}, {id: 2, name: 'LED-LCD'}, {id: 3, name: 'Plasma'}, {id: 4, name: 'CRT'}, {id: 5, name: 'Other'}],
        //   condition: 'this.electrical.category=="monitor"',
        //   'name': 'monitor_specification',
        //   'title': 'Monitor Specification',
        //   category: 'monitor',
        //   column: true,
        //   no_edit: true,
        //   class: 'xs12',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: '8mm'}, {id: 2, name: '16mm'}, {id: 3, name: '35mm'}, {id: 4, name: 'DLP'}, {id: 5, name: 'CRT'}, {id: 6, name: 'other'}],
        //   'name': 'projector_specification',
        //   'title': 'Projector Specification',
        //   category: 'projector',
        //   column: true,
        //   no_edit: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: 'electric motor'}, {id: 2, name: 'pneumatic motor'}, {id: 3, name: 'hydraulic motor'}, {id: 4, name: 'other'}],
        //   'name': 'motor_specification',
        //   'title': 'Motor Specification',
        //   category: 'motor',
        //   column: true,
        //   no_edit: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: 'Incandescent light bulb'}, {id: 2, name: 'LED'}, {id: 3, name: 'Halogen'}, {id: 4, name: 'Arc lamp'}, {id: 5, name: 'Gas-discharged lamp (fluorescent, neon)'}, {id: 6, name: 'other'}],
        //   'name': 'bulb_specification',
        //   'title': 'Bulb Specification',
        //   category: 'bulb',
        //   column: true,
        //   no_edit: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   name: 'switch',
        //   title: 'Switch, Counter - Specification',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   category: 'switch',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'other',
        //   title: 'Other - Specification',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   category: 'other',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   'ctype': 'radio',
        //   'selection': [{id: 1, name: 'Unique/Existing'}, {id: 2, name: 'Dedicated/Existing'}, {id: 3, name: 'Historic Dedicated/Existing'}, {id: 4, name: 'Non-dedicated/Required'}],
        //   'name': 'monitor_origin',
        //   'title': 'Monitor - Origin',
        //   category: 'monitor',
        //   no_edit: true,
        //   column: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },      
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: 'Unique/Existing'}, {id: 2, name: 'Dedicated/Existing'}, {id: 3, name: 'Historic Dedicated/Existing'}, {id: 4, name: 'Non-dedicated/Required'}],
        //   'name': 'projector_origin',
        //   'title': 'Projector - Origin',
        //   category: 'projector',
        //   no_edit: true,
        //   column: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },      
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: 'Unique/Existing'}, {id: 2, name: 'Dedicated/Existing'}, {id: 3, name: 'Historic Dedicated/Existing'}, {id: 4, name: 'Non-dedicated/Required'}],
        //   'name': 'motor_origin',
        //   'title': 'Motor - Origin',
        //   category: 'motor',
        //   no_edit: true,
        //   column: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },      
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: 'Unique/Existing'}, {id: 2, name: 'Dedicated/Existing'}, {id: 3, name: 'Historic Dedicated/Existing'}, {id: 4, name: 'Non-dedicated/Required'}],
        //   'name': 'bulb_origin',
        //   'title': 'Bulb - Origin',
        //   category: 'bulb',
        //   column: true,
        //   no_edit: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },      
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: 'Unique/Existing'}, {id: 2, name: 'Dedicated/Existing'}, {id: 3, name: 'Historic Dedicated/Existing'}, {id: 4, name: 'Non-dedicated/Required'}],
        //   'name': 'switch_origin',
        //   'title': 'Switch, Counter - Origin',
        //   category: 'switch',
        //   column: true,
        //   no_edit: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },      
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: 'Unique/Existing'}, {id: 2, name: 'Dedicated/Existing'}, {id: 3, name: 'Historic Dedicated/Existing'}, {id: 4, name: 'Non-dedicated/Required'}],
        //   'name': 'other_origin',
        //   'title': 'Other- Specification - Origin',
        //   category: 'other',
        //   column: true,
        //   no_edit: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   name: 'electrical.brand',
        //   title: 'Brand',
        //   ctype: 'text-short',
        //   class: 'xs12 md6',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'type_and_model',
        //   title: 'Type and Model',
        //   ctype: 'text-short',
        //   class: 'xs12 md6',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'sn',
        //   title: 'Serial Number',
        //   ctype: 'text-short',
        //   no_edit: true,
        //   class: 'xs12 md6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'an',
        //   title: 'Accession Number Tech Database TBA21',
        //   ctype: 'text-short',
        //   no_edit: true,
        //   class: 'xs12 md6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'production_date',
        //   title: 'Date of Production',
        //   ctype: 'text-short',
        //   model_string: 'electrical',
        //   class: 'xs12 md6',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'interfaces',
        //   title: 'Interfaces',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'number_of_parts',
        //   title: 'Number of Parts',
        //   ctype: 'text-short',
        //   class: 'xs12 md6',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'power_requirement',
        //   title: 'Power Requirement',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'height',
        //   title: 'Height',
        //   ctype: 'text-short',
        //   'suffix': ' cm',
        //   'class': 'xs12 md4',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'width',
        //   title: 'Width',
        //   ctype: 'text-short',
        //   no_edit: true,
        //   'suffix': ' cm',
        //   'class': 'xs12 md4',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'depth',
        //   title: 'Depth',
        //   ctype: 'text-short',
        //   'suffix': ' cm',
        //   no_edit: true,
        //   'class': 'xs12 md4',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'weight',
        //   title: 'Weight',
        //   no_edit: true,
        //   ctype: 'text-short',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'specs',
        //   title: 'Specifications on installation',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'modification',
        //   title: 'Modification',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'periphals',
        //   title: 'Periphals',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'associated_items',
        //   title: 'Associated items',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
      ],
      showUpload: false,
      show: false,
      showme: false,
      electrical: {
        category: '',
        monitor_specification: '',
        projector_specification: '',
        motor_specification: '',
        bulb_specification: '',
        switch: '',
        other: '',
        monitor_origin: '',
        projector_origin: '',
        motor_origin: '',
        bulb_origin: '',
        switch_origin: '',
        other_origin: '',
        interfaces: '',
        brand: '',
        sn: '',
        an: '',
        production_date: '',
        number_of_parts: '',
        power_requirement: '',
        height: '',
        width: '',
        depth: '',
        weight: '',
        specs: '',
        modification: '',
        periphals: '',
        associated_items: ''
      }
    }),
    computed: {
      all_electricals () {
        return this.$store.state.electricals
        // console.log(todos)
        // return todos
      },      // c () {
      // c () {
      //   return this.showme
      // }
    },
    methods: {
      // show_field (f) {
      //   if (f.condition) {
      //     this.showme = true
      //     var a = f.condition
      //     // console.log(a)
      //     return eval(a)
      //   } else {
      //     return true
      //   }
        // return Function('"use strict";return (a)')()
      // },
      download () {},
      // add () {
      //   this.electricals.push(this.electrical)
      //   this.showUpload=!this.showUpload
      // },
      deleteDevice (d) {
        // var index = exhibition_artworks.indexOf(e);
        // console.log('index = ' + index)
        // exhibition_artworks.splice(index,1)
        this.$store.dispatch('deleteDevice',d)
        this.dialog = false
      },      
      delete_electrical () {},
      done_electrical () {},
      save_electrical () {
        this.electrical.artwork_id = this.artwork.id
        // this.electrical.done = false
        this.electrical.id = this.findMinMax(this.all_electricals)+1
        this.$store.commit('ADD_ELECTRICAL', this.electrical)
        // this.all_electricals.push(this.electrical)
        this.showUpload = false
        this.electrical = {
          description: '',
          title: '',
          deadline: '',
          done: false
        }
        // var aelectrical = Object.keys(this.electrical).forEach(k => this.electrical[k]='')
        // console.log(aelectrical)
      },
      findMinMax(arr) {
        if (arr===undefined || arr.length===0) {
          return 1
        } else {
          let max = arr[0].id
          for (let i = 1, len=arr.length; i < len; i++) {
            let v = arr[i].id
            max = (v > max) ? v : max
          }
          // console.log(max)
          return max
        }
      }
    },
    components: {HeaderElements,ElementsTable}
  }
</script>

<style scoped>
/* .card { min-width:250px;} */
</style>



// WEBPACK FOOTER //
// src/components/artworks/Electrical.vue